import _ from 'lodash'
import moment from 'moment'
import React from 'react'
import DatePicker from 'react-datepicker'
import { Field, reduxForm } from 'redux-form'

const ChecklistResults = props => {
  const {
    list, handleSubmit, submitting, reset, checklists, listChecklistResults,
    checkDate, onCheckDateChanged, checklistId
  } = props
  const checklistOptions = checklists ? _.map(checklists, (checklist) => (
    <option key={checklist.id} value={checklist.id}>{checklist.projectName}</option>
  )) : undefined
  let currentMainAreaName
  return (
    <div>
      <div className="pd-x-20 pd-sm-x-30 pd-t-20 pd-sm-t-30">
        <h4 className="tx-gray-800 mg-b-5">Checklist Result</h4>
      </div>
      <div className="br-pagebody">
        <div className="br-section-wrapper">
          <div className="row">
            <div className="col-lg-12">
              <form className="form-layout form-layout-2"
                      onSubmit={handleSubmit((values) => {listChecklistResults(values, checkDate)})}>
                <div className="row no-gutters">
                  <div className="col-md-8">
                    <div className="form-group">
                      <label htmlFor="checklistId" className="form-control-label">Project:</label>
                      <Field name="checklistId" component="select" className="form-control">
                        <option/>
                        {checklistOptions}
                      </Field>
                    </div>
                  </div>
                  <div className="col-md-4">
                    <div className="form-group">
                      <label htmlFor="checkDate" className="form-control-label">Check Date:</label>
                      <DatePicker className="form-control" placeholderText="Click to select a date"
                                  dateFormat="DD/MM/YYYY"
                                  selected={checkDate}
                                  onChange={onCheckDateChanged}/>
                    </div>
                  </div>
                  <div className="col-md-12">
                    <div className="form-layout-footer form-layout-footer bd pd-20 bd-t-0">
                      <button type="submit" className="btn btn-teal mg-r-10" disabled={submitting}>Search</button>
                      <button type="button" className="btn btn-secondary" disabled={submitting} onClick={() => {
                        reset()
                        onCheckDateChanged()
                      }}>Clear
                      </button>
                    </div>
                  </div>
                </div>
              </form>
            </div>
            <br/>
            <div className="col-lg-12">
              {
                list ?
                  <div className="mg-y-30">
                    <table className="table table-bordered table-colored table-dark">
                      <thead>
                      <tr>
                        <th scope="col">Main Area</th>
                        <th scope="col">Defect Area</th>
                        <th scope="col">Result</th>
                        <th scope="col">Verified By</th>
                        <th scope="col">Verified Date</th>
                      </tr>
                      </thead>
                      <tbody>
                      {list.length > 0 ? list.map(row => {
                        let mainAreaName = ''
                        if (currentMainAreaName !== row.mainAreaName) {
                          currentMainAreaName = row.mainAreaName
                          mainAreaName = currentMainAreaName
                        }
                        return (
                          <tr key={row.id}>
                            <td>{mainAreaName}</td>
                            <td>{row.defectAreaName}</td>
                            <td>{row.result}</td>
                            <td>{row.verifiedByUser ? row.verifiedByUser.name : 'N/A'}</td>
                            <td>{row.verifiedDate ? moment(row.verifiedDate).format('YYYY-MM-DD') : 'N/A'}</td>
                          </tr>
                        )
                      }) : <td>No records found.</td>}
                      </tbody>
                    </table>
                    <div className="row justify-content-end mg-r-0">
                      <button type="button" className="btn btn-primary" disabled={!list || list.length === 0}
                              onClick={() => {listChecklistResults({ checklistId }, checkDate, true)}}>
                        Download
                      </button>
                    </div>
                  </div>
                  : undefined
              }
            </div>
          </div>
        </div>
      </div>
    </div>      
  )
}

export default reduxForm({
  form: 'checklist-results'
})(ChecklistResults)


// WEBPACK FOOTER //
// ./src/components/ChecklistResults.js